import request from '../request';

const serve = {
  addCarbonFootprint(params) {
    return request.post('/user-center/carbonFootprint/add', params);
  },
  queryDetailForSupplier(params) {
    return request.post(
      '/user-center/carbonFootprint/queryDetailForSupplier',
      params
    );
  },
  queryPageForSupplier(params) {
    return request.post(
      '/user-center/carbonFootprint/queryPageForSupplier',
      params
    );
  },
  removeCarbonFootprint(params) {
    return request.post('/user-center/carbonFootprint/remove', params);
  },
  // 新版碳足迹
  submit(params) {
    return request.post('/user-center/green/submit', params);
  },
  draft(params) {
    return request.post('/user-center/green/draft', params);
  },

  getDraft(params) {
    return request.fetch('/user-center/green/getDraft', params);
  },

  queryPage(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/queryPage`, params);
  },

  detail(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/detail`, params);
  },
  update(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/update`, params);
  },
  delete(params, type = 'greenCarbonCert') {
    return request.post(`/user-center/${type}/delete`, params);
  },
};

export default serve;
